import Home from "pages/Home";

export const Routes = {
  home: {
    component: Home,
    path: "/",
    exact: true,
  },
};
